import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { CheckCircle2, Rocket, Lightbulb, Zap, Download, ShieldCheck } from 'lucide-react';
export function PremiumProduct() {
  const learnings = ['Cómo funciona Amazon FBM desde cero', 'Cómo publicar productos correctamente', 'Cómo gestionar pedidos y envíos', 'Cómo vender sin usar bodegas FBA', 'Cómo comenzar con menor inversión', 'Cómo trabajar desde casa usando Amazon', 'Cómo encontrar productos rentables', 'Cómo configurar tu cuenta correctamente'];
  return <section className="bg-brand-beige py-24 px-6" data-id="element-509">
      <div className="max-w-6xl mx-auto" data-id="element-510">
        {/* Title */}
        <FadeIn data-id="element-511">
          <div className="text-center mb-16" data-id="element-512">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-brand-green/10 rounded-full mb-6" data-id="element-513">
              <Rocket className="w-8 h-8 text-brand-green" data-id="element-514" />
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-brand-green" data-id="element-515">
              APRENDE A VENDER EN AMAZON FBM DESDE CERO
            </h2>
          </div>
        </FadeIn>

        {/* Two-column block: image left, text + button right */}
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16 mb-20" data-id="element-516">
          {/* Image */}
          <div className="flex-1 w-full" data-id="element-517">
            <FadeIn data-id="element-518">
              <img src="https://cdn.magicpatterns.com/uploads/j1AcudPF6ryWv1yAHEPiK7/Pottada_FBM.png" alt="Aprende a Vender en Amazon FBM Desde Cero - Guía Premium" className="w-full h-auto rounded-2xl shadow-2xl object-contain" data-id="element-519" />
            </FadeIn>
          </div>

          {/* Text + button */}
          <div className="flex-1 w-full text-center lg:text-left" data-id="element-520">
            <FadeIn delay={0.2} data-id="element-521">
              <h3 className="text-3xl md:text-4xl font-bold text-brand-green leading-tight mb-6" data-id="element-522">
                APRENDE A VENDER EN AMAZON FBM DESDE CERO
              </h3>

              <p className="text-lg text-brand-text/80 mb-4 leading-relaxed" data-id="element-523">
                Descubre cómo vender productos usando Amazon sin necesidad de
                enviar inventario a bodegas FBA.
              </p>
              <p className="text-lg text-brand-text/70 mb-4 leading-relaxed" data-id="element-524">
                Aprende paso a paso cómo publicar productos, gestionar pedidos,
                configurar tu cuenta y comenzar a generar ingresos desde casa
                utilizando el sistema FBM de Amazon.
              </p>
              <p className="text-lg text-brand-text/70 mb-8 leading-relaxed pb-6 border-b border-brand-green/10" data-id="element-525">
                Ideal para principiantes que desean empezar con menor inversión
                y mayor control de sus productos.
              </p>

              {/* Price above button (matching FBA style) */}
              <div className="mb-5" data-id="element-526">
                <p className="text-xs font-semibold uppercase tracking-wider text-brand-text/50 mb-1 lg:text-left text-center" data-id="element-527">
                  🔥 HOY SOLO
                </p>
                <p className="text-5xl md:text-6xl font-bold text-brand-green lg:text-left text-center" data-id="element-528">
                  $15.99
                </p>
                <p className="text-xs font-bold text-brand-gold uppercase tracking-wider mt-2 lg:text-left text-center" data-id="element-529">
                  ⚡ Precio de lanzamiento — puede cambiar en cualquier momento
                </p>
              </div>

              <Button onClick={() => window.open('https://43skvt-1y.myshopify.com/products/aprende-a-vender-en-amazon-fbm-desde-cero', '_blank', 'noopener,noreferrer')} className="w-full sm:w-auto text-lg px-10 py-5" data-id="element-530">
                QUIERO APRENDER AMAZON FBM
              </Button>
              <div className="flex flex-col sm:flex-row items-center lg:justify-start justify-center gap-4 sm:gap-6 text-brand-text/50 text-xs mt-4" data-id="element-531">
                <span className="flex items-center gap-1.5" data-id="element-532">
                  <Zap className="w-3.5 h-3.5 text-brand-green" data-id="element-533" />
                  ACCESO INMEDIATO
                </span>
                <span className="flex items-center gap-1.5" data-id="element-534">
                  <Download className="w-3.5 h-3.5 text-brand-green" data-id="element-535" />
                  DESCARGA DIGITAL
                </span>
                <span className="flex items-center gap-1.5" data-id="element-536">
                  <ShieldCheck className="w-3.5 h-3.5 text-brand-green" data-id="element-537" />
                  COMPRA SEGURA
                </span>
              </div>
            </FadeIn>
          </div>
        </div>

        {/* Lo que aprenderás */}
        <div className="max-w-4xl mx-auto" data-id="element-538">
          <FadeIn delay={0.15} data-id="element-539">
            <div className="bg-white rounded-2xl p-8 md:p-10" data-id="element-540">
              <div className="flex items-center gap-3 mb-6" data-id="element-541">
                <Rocket className="w-6 h-6 text-brand-gold" data-id="element-542" />
                <h3 className="text-xl md:text-2xl font-bold text-brand-green" data-id="element-543">
                  ¿QUÉ APRENDERÁS CON AMAZON FBM?
                </h3>
              </div>
              <div className="space-y-4" data-id="element-544">
                {learnings.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-545">
                    <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-546" />
                    <p className="text-base md:text-lg text-brand-text/80 font-medium" data-id="element-547">
                      {item}
                    </p>
                  </div>)}
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}